module.exports = __webpack_public_path__ + "img/золотой букет 90х100.bc74481d.jpg";